export default {
  isLoggedIn: false,
  showFullLoader: false,
  authToken: '',
  userDetails: {},
  deletePayload: {},
  supportList: {},
  filterByActiveUser: 0,
  isChangesMade: false,
  changeLostDialog: false,
  isLocalDelete: false,
  dialogOkCb: () => { },
  dialogCancelCb: () => { },
  FORM_TYPE: {
    TEXT: 'text',
    TEXTAREA: 'textarea',
    CHECKBOX: 'checkbox',
    SELECT: 'select',
    AUTO_COMPLETE: 'auto_complete',
    COMBOBOX: 'combobox',
    DATE: 'date',
    PASSWORD: 'password',
    NUMBER: 'number',
    DATEPICKER: 'datepicker',
    QUICKADD: 'quickadd',
    TIMEPICKER: 'timepicker',
    FILES: 'files',
    ALERT: 'alert',
    COLORPICKER: 'color',
    BUTTON: 'btn',
    BTNDROPDOWN: 'btnDropdown',
    RADIO: 'radio',
    DIVIDER: 'divider',
    LINK: 'link'
  },
  listOfModules: [],
  listOfUnits: [],
  listOfUsers: [],
  listOfMailboxes: [],
  listOfTypes: [],
  listOfPriorities: [],
  listOfStatus: [],
  listOfUserRoles: [],
  listOfGroups: [],
  listOfProductGroups: [],
  listOfDevationCategory: [],
  listOfDevationStatus: [],
  listOfDevationLocation: [],
  listOfCustomerPriorities: [],
  listofCustomerIndustries: [],
  listofCustomerShipments: [],
  listOfSalesAccounts: [],
  listOfSuppliers: [],
  listOfCurrency: [],
  listOfWarehouse: [],
  listOfLocations: [],
  listOfCustomers: [],
  listOfDepartments: [],
  listOfWorkflows: [],
  listOfProductClasses: [],
  // LIST ITEMS
  CRM_INDEX: {},
  USER_INDEX: {},
  USERROLE_INDEX: {},
  PRODUCTGROUP_INDEX: {},
  PRIORITIES_INDEX: {},
  TICKETSTATUS_INDEX: {},
  TICKETTYPE_INDEX: {},
  PRODUCT_UNIT_INDEX: {},
  GROUP_INDEX: {},
  TICKETS_INDEX: {},
  MAIL_CONFIG_INDEX: {},
  PRODUCT_INDEX: {},
  ORDER_INDEX: {},
  ORDER_LINE_INDEX: {},
  DEVIATION_INDEX: {},
  DEVIATION_CATEGORY_INDEX: {},
  DEVIATION_STATUS_INDEX: {},
  DEVIATION_LOCATION_INDEX: {},
  DEVIATION_DEPARTMENT_INDEX: {},
  DEVIATION_WORKFLOW_INDEX: {},
  DEVIATION_ORDER_INDEX: {},
  DEVIATION_WORKFLOW_STATES_INDEX: {},
  F_TICKETS: {},
  F_CUSTOMERS: {},
  CUSTOMER_SHIPMENT_INDEX: {},
  CUSTOMER_PRIORITIES_INDEX: {},
  CUSTOMER_INDUSTRIES_INDEX: {},
  CURRENCY_INDEX: {},
  CURRENCY_ACTION_INDEX: {},
  SALES_ACCOUNTS_INDEX: {},
  PRODUCED_PRODUCTS: {},
  WAREHOUSE_SETTINGS: {},
  WAREHOUSE_LOCATION: {},
  STOCK_INDEX: {},
  WH_ORDER_INDEX: {},
  F_WH_ORDERS: {},
  F_WAREHOUSE: {},
  F_PRODUCT: {},
  F_SALES_ORDER: {},
  CCSHEET_INDEX: {},
  GROSS_MARGIN_INDEX: {},
  TOOLS_INDEX: {},
  DEVIATION_PRODUCT_CLASS_INDEX: {},
  PRICE_HISTORY_INDEX: {},
  PROPS_INDEX: {},
  FORM_PROPS_INDEX: {},
  ORDER_CHECKLIST_INDEX: {},
  F_WH_PRODUCT_BATCHES: {},
  BATCHES_INDEX: {},
  // ProductionOrder from arven
  PRODUCT_ORDER_INDEX: {},
  PRODCUCT_ARCHIVED_INDEX: {},
  PRODUCT_IN_PRODUCTION: {},
  PRODCUCTION_BY_PRODUCT: {},
  showDialog: false,
  workFlowStates: []
}
